import React, { useState } from 'react'
import './LoginAndSecurity.css'
import { useHistory } from 'react-router-dom'
import TransparentLoader from './../../navigationComponents/loader/TransparentLoader'
import { Auth } from 'aws-amplify'
import './../MyAccount.css'
import { useAuth } from '../../auth/Auth'
import { GpButton, GpFormField, Icon } from '../../components/gp'

const iconBtn = {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    color: 'var(--gp-ink-mute)',
    display: 'inline-flex',
    padding: 4,
}

const LoginAndSecurity = () => {
    const history = useHistory()
    const auth = useAuth()

    const [showPassword, setShowPassword] = useState(false)
    const [password, setPassword] = useState('')
    const [oldPassword, setOldPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [incorrectPassword, setIncorrectPassword] = useState(false)
    const [limitHit, setLimitHit] = useState(false)
    const [success, setSuccess] = useState(false)

    const resetPasswords = () => {
        setOldPassword('')
        setPassword('')
    }

    const handleUpdate = () => {
        setSuccess(false)
        setIncorrectPassword(false)
        setLimitHit(false)
        setIsLoading(true)
        auth.isUserLoggedIn()
            .then((user) => Auth.changePassword(user, oldPassword, password))
            .then(() => {
                setIsLoading(false)
                setSuccess(true)
                resetPasswords()
            })
            .catch((err) => {
                setIsLoading(false)
                if (err.toString().includes('limit')) {
                    setLimitHit(true)
                } else {
                    setIncorrectPassword(true)
                }
                resetPasswords()
            })
    }

    const canSubmit = oldPassword.length > 0 && password.length > 0 && !isLoading

    return (
        <div className="edit-info-page-container">
            <nav
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    marginBottom: 22,
                    flexWrap: 'wrap',
                }}
            >
                <span
                    onClick={() => history.push('/my-account')}
                    style={{
                        font: '400 22px/1.2 var(--gp-font)',
                        color: 'var(--gp-ink-mute)',
                        cursor: 'pointer',
                    }}
                >
                    My account
                </span>
                <span style={{ color: 'var(--gp-ink-mute)', display: 'flex' }}>
                    <Icon name="chevron" size={16} stroke={1.5} />
                </span>
                <span
                    style={{
                        font: '500 22px/1.2 var(--gp-font)',
                        color: 'var(--gp-ink)',
                    }}
                >
                    Login & security
                </span>
            </nav>

            <p
                style={{
                    font: 'var(--gp-body)',
                    color: 'var(--gp-ink-mute)',
                    margin: '0 0 28px',
                }}
            >
                Update the password you use to sign in.
            </p>

            <div
                className="edit-body"
                style={{ maxWidth: 480, marginTop: 0, padding: 24 }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                    <GpFormField
                        label="Old password"
                        icon="lock"
                        type={showPassword ? 'text' : 'password'}
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        placeholder="Enter your current password"
                        autoComplete="current-password"
                        trailing={
                            <button
                                type="button"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={
                                    showPassword ? 'Hide password' : 'Show password'
                                }
                                style={iconBtn}
                            >
                                <Icon
                                    name={showPassword ? 'eyeOff' : 'eye'}
                                    size={18}
                                    stroke={1.75}
                                />
                            </button>
                        }
                    />

                    <GpFormField
                        label="New password"
                        icon="lock"
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Choose a new password"
                        autoComplete="new-password"
                        trailing={
                            <button
                                type="button"
                                onClick={() => setShowPassword((v) => !v)}
                                aria-label={
                                    showPassword ? 'Hide password' : 'Show password'
                                }
                                style={iconBtn}
                            >
                                <Icon
                                    name={showPassword ? 'eyeOff' : 'eye'}
                                    size={18}
                                    stroke={1.75}
                                />
                            </button>
                        }
                        helpText="Use at least 8 characters with a mix of upper/lowercase letters, numbers and symbols."
                    />
                </div>
            </div>

            {!isLoading && incorrectPassword && (
                <div
                    style={{
                        font: 'var(--gp-caption)',
                        color: 'var(--gp-danger)',
                        marginTop: 14,
                    }}
                >
                    Incorrect password. Please try again.
                </div>
            )}
            {!isLoading && limitHit && (
                <div
                    style={{
                        font: 'var(--gp-caption)',
                        color: 'var(--gp-danger)',
                        marginTop: 14,
                    }}
                >
                    Maximum attempts reached. Please try again later.
                </div>
            )}
            {!isLoading && success && (
                <div
                    style={{
                        font: 'var(--gp-caption)',
                        color: 'var(--gp-brand)',
                        marginTop: 14,
                    }}
                >
                    Password updated.
                </div>
            )}
            {isLoading && (
                <div style={{ marginTop: 14 }}>
                    <TransparentLoader />
                </div>
            )}

            <div style={{ marginTop: 18 }}>
                <GpButton variant="primary" onClick={handleUpdate} disabled={!canSubmit}>
                    {isLoading ? 'Updating…' : 'Update password'}
                </GpButton>
            </div>
        </div>
    )
}

export default LoginAndSecurity
